/**
 * UniqueBadge — pastille sémantique aux couleurs de la charte.
 *
 * Tons disponibles :
 *   - gold      : information primaire / source IA
 *   - urgent    : quadrant Q1 (urgent + important)
 *   - important : quadrant Q2 (important)
 *   - normal    : quadrant Q3 (urgent peu important)
 *   - defer     : quadrant Q4 (à déléguer)
 *   - email / call / manual : sources de tâches
 */
import type { HTMLAttributes, ReactNode } from 'react';

export type UniqueBadgeTone =
  | 'gold'
  | 'urgent'
  | 'important'
  | 'normal'
  | 'defer'
  | 'email'
  | 'call'
  | 'manual';

export interface UniqueBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: UniqueBadgeTone;
  icon?: ReactNode;
  children: ReactNode;
}

const toneClassMap: Record<UniqueBadgeTone, string> = {
  gold: 'unique-badge unique-badge--gold',
  urgent: 'unique-badge unique-badge--urgent',
  important: 'unique-badge unique-badge--important',
  normal: 'unique-badge unique-badge--normal',
  defer: 'unique-badge unique-badge--defer',
  email: 'unique-badge unique-badge--gold',
  call: 'unique-badge unique-badge--important',
  manual: 'unique-badge unique-badge--defer',
};

export function UniqueBadge({
  tone = 'gold',
  icon,
  className = '',
  children,
  ...rest
}: UniqueBadgeProps) {
  return (
    <span className={`${toneClassMap[tone]} ${className}`.trim()} {...rest}>
      {icon ? <span className="flex items-center">{icon}</span> : null}
      {children}
    </span>
  );
}
